import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

const PdfPreviewer = ({ selectedContent, showLoader, setShowLoader, setParentRef, setIsInitialLoad }) => {
    const contentRef = useRef();
    const [pdfUrl, setPdfUrl] = useState(null);

    const generatePdf = async () => {
        const input = contentRef.current;
        setParentRef(contentRef.current)
        if (contentRef.current) {
            html2canvas(input, { scale: 2, useCORS: true, imageTimeout: 5000 }).then((canvas) => {
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF("p", "mm", "a4");
                const imgWidth = 210; // A4 width in mm
                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
                const pdfBlob = pdf.output("blob");

                const pdfBlobUrl = URL.createObjectURL(pdfBlob);
                setPdfUrl(pdfBlobUrl);
                setShowLoader(false);
                setIsInitialLoad(false);
            });
        }
    };

    useEffect(() => {
        if (selectedContent) {
            generatePdf();
        }
    }, [selectedContent])

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div>
            {showLoader &&
                <div>
                    <div ref={contentRef}>
                        <div id="test" dangerouslySetInnerHTML={{ __html: selectedContent }} />
                    </div>
                </div>
            }
            {/* PDF Viewer */}
            {pdfUrl && (
                <div style={{ border: "1px solid #ccc", height: "500px" }}>
                    <Worker workerUrl="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js">
                        <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                    </Worker>
                </div>
            )}
        </div>
    );
};

export default PdfPreviewer;
